import offDates from '../api/offDates'
import { FETCH_OFFDATES } from './actions.types'
import { SET_OFFDATES } from './mutation.types'

export default {
  namespaced: true,
  state: {
    offdates: []
  },
  mutations: {
    [SET_OFFDATES]: (state, payload) => {
      state.offdates = payload
    }
  },
  actions: {
    [FETCH_OFFDATES]: async ({ commit }, options) => {
      return offDates.index(options).then(response => {
        let daysOff = response.data.data
        commit(SET_OFFDATES, daysOff)
        return daysOff
      })
    }
  }
}
